<!--INFORMATION BANNER-->
<div
  class="info-banner margin-bottom-large"
  [id]="id"
  [ngClass]="isFlex ? 'fixed-height' : ''"
  [attr.data-beyond-information-banner-id]="id"
  *ngIf="display">
  <h3 [innerHTML]="title"></h3>
  <div
    class="flexbox align-items-center"
    [class.flex-direction-row]="flexDirection !== 'column'"
    [class.flex-direction-column]="flexDirection === 'column'">
    <!--INFO BANNER ICON-->
    <span><i [ngClass]="icon ? icon : ''"></i></span>
    <!--END INFO BANNER ICON-->
    <!--INFO CONTENT BODY-->
    <p class="full-width" [ngClass]="customClass ? customClass : ''" [innerHTML]="bodyText"></p>
    <!--END INFO CONTENT BODY-->
    <!--ROUTE BUTTON-->
    <app-route-button
      *ngIf="showButton"
      [id]="id"
      [route]="route"
      [routeType]="routeType"
      [buttonRoute]="route"
      [queryParams]="queryParams"
      (buttonClick)="onClick($event)"
      [actionLabel]="actionLabel"
      [customButtonCss]="['btn', 'btn-primary', 'list']">
    </app-route-button>
    <!--END ROUTE BUTTON-->
  </div>
</div>
<!--END INFORMATION BANNER-->
